import {
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';
import { ExternalResourcesApi } from '@teamsystem/backstage-plugin-external-resources-react';

export class ExternalResourcesClient implements ExternalResourcesApi {

  private readonly fetchApi: FetchApi;
  private readonly discoveryApi: DiscoveryApi;

  constructor(options: { fetchApi: FetchApi; discoveryApi: DiscoveryApi; }) {
    this.fetchApi = options.fetchApi;
    this.discoveryApi = options.discoveryApi;
  }

  private async getBaseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('external-resources');
  }

  async getExternalResourcesAccessURL(filenames: string[]): Promise<string[]> {
    const url = `${await this.getBaseUrl()}`;
    const response = await this.fetchApi.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filenames),
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch external resources access URL: ${response.statusText}`);
    }

    return response.json();
  }
}